import React from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { getReportReasonsQuery } from '../../../../../api/queries';
import useBugsnagNotifier from '../../../../../hooks/useBugsnagNotifier';
import { ReportModal } from '../ReportModal';
import { NewRadioButton } from '../../../../NewRadioButton';
import { ReportSectionList } from './styled';

interface ReportListProps {
  isOpenModal: boolean;
  currentValue?: string;
  onReportModalClose: () => void;
  onReportItemClickHandler: (reason: { id: string; reason: string }) => void;
}

export const ReportList: React.FC<ReportListProps> = ({
  isOpenModal,
  currentValue,
  onReportModalClose,
  onReportItemClickHandler
}) => {
  const { t } = useTranslation();

  const { error, loading, data } = useQuery(getReportReasonsQuery, {
    ssr: false
  });
  const reasonsList = data?.reportReasons || [];

  useBugsnagNotifier(error);

  if (loading) return null;

  return (
    <ReportModal
      isOpen={isOpenModal}
      closeHandler={onReportModalClose}
      title={t('pages.current_item.buttons.complain')}
    >
      <ReportSectionList data-cy="report-section__list">
        {reasonsList.map(({ id, reason }) => (
          <NewRadioButton
            key={id}
            data={{ id, name: reason }}
            currentValue={currentValue || ''}
            onChangeHandler={() => onReportItemClickHandler({ id, reason })}
            name="report-reason"
            cypress="report-section__list-item"
          />
        ))}
      </ReportSectionList>
    </ReportModal>
  );
};
